document.addEventListener("DOMContentLoaded", () => {

    const swatches = document.querySelectorAll(".akini-swatch");

    const colorName = document.getElementById("AkiniColorName");
    const colorStory = document.getElementById("AkiniColorStory");

    if (!swatches.length || !colorName || !colorStory) return;

    const originalName = colorName.textContent;
    const originalStory = colorStory.textContent;

    swatches.forEach((swatch)=>{

        swatch.addEventListener("mouseenter", ()=>{

            colorName.style.opacity = 0;
            colorStory.style.opacity = 0;

            setTimeout(()=>{

                colorName.textContent = swatch.dataset.colorName;
                colorStory.textContent = swatch.dataset.colorStory;

                colorName.style.opacity = 1;
                colorStory.style.opacity = 1;

            },150);

        });

        swatch.addEventListener("mouseleave", ()=>{

            if(!swatch.classList.contains("active")){

                colorName.style.opacity = 0;
                colorStory.style.opacity = 0;

                setTimeout(()=>{

                    colorName.textContent = originalName;
                    colorStory.textContent = originalStory;

                    colorName.style.opacity = 1;
                    colorStory.style.opacity = 1;

                },150);

            }

        });

    });

});

// Collection card image switching
document.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll(".card-wrapper").forEach(card => {

        const image = card.querySelector(".akini-card-main-image");

        if (!image) return;

        const original = image.src;

        card.querySelectorAll(".akini-card-swatch").forEach(swatch => {

            swatch.addEventListener("mouseenter", () => {

                const next = swatch.dataset.image;

                if (next) {

                    image.style.opacity = ".35";

                    setTimeout(() => {

                        image.src = next;
                        image.style.opacity = "1";

                    }, 120);

                }

            });

        });

        card.addEventListener("mouseleave", () => {

            image.style.opacity = ".35";

            setTimeout(() => {

                image.src = original;
                image.style.opacity = "1";

            }, 120);

        });

    });

});

/* ==========================================
   Collection Card Hover Images
========================================== */

document.querySelectorAll(".card-wrapper").forEach((card) => {

    const image = card.querySelector(".akini-card-main-image");

    if (!image) return;

    const originalSrc = image.getAttribute("src");
    const originalSrcset = image.getAttribute("srcset");

    card.querySelectorAll(".akini-card-swatch").forEach((swatch)=>{

        swatch.addEventListener("mouseenter", ()=>{

            const img = swatch.dataset.image;

            image.src = img;
            image.srcset = img;

        });

        swatch.addEventListener("mouseleave", ()=>{

            image.src = originalSrc;
            image.srcset = originalSrcset;

        });

    });

});